// @ts-nocheck
import * as types from '../types';

const initialState = {
    data: [],
    drawer: {
        data: {},
        visible: false,
    },
    selectedApp: null,
    filters: {
        keyword: '',
    },
    appTranslations: {},
    appTranslationKeys: {},
};

const translations = (state = initialState, action) => {
    const { payload, type } = action;

    switch (type) {
        case types.TRANSLATIONS_DATA_CHANGED: {
            return {
                ...state,
                data: payload,
            };
        }
        case types.TRANSLATIONS_DRAWER_PROPS_CHANGED: {
            return {
                ...state,
                drawer: payload,
            };
        }
        case types.TRANSLATIONS_FILTERS_CHANGED: {
            return {
                ...state,
                filters: { ...state.filters, ...payload },
            };
        }
        case types.TRANSLATIONS_FILTERS_CLEARED: {
            return {
                ...state,
                filters: initialState.filters,
            };
        }
        case types.TRANSLATIONS_SELECTED_APP_CHANGED: {
            return {
                ...state,
                selectedApp: payload,
            };
        }
        default:
            return state;
    }
};

export default translations;
